import React from 'react';
import { clsx } from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  icon?: React.ReactNode;
  containerClassName?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  hint,
  icon,
  containerClassName,
  className,
  id,
  ...props
}) => {
  return (
    <div className={clsx('form-group', containerClassName)}>
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <div className="relative">
        {icon && <span className="form-icon form-icon-left">{icon}</span>}
        <input
          id={id}
          className={clsx(
            'form-input',
            icon && 'form-input-icon',
            error && 'form-input-error',
            className
          )}
          {...props}
        />
      </div>
      {error ? (
        <p className="form-error">{error}</p>
      ) : (
        hint && <p className="form-hint">{hint}</p>
      )}
    </div>
  );
};
